export const SET_INITIAL_INVENTORY = "SET_INITIAL_INVENTORY";
export const UPDATE_INGREDIENTS_IN_INVENTORY = "UPDATE_INGREDIENTS_IN_INVENTORY";
export const CLEAR_INVENTORY = "CLEAR_INVENTORY";

export const INVENTORY_UPDATE_ACTION = {
    "ADD" : "ADD",
    "REMOVE" : "REMOVE",
    'BASED_ON_QUANTITY' : "BASED_ON_QUANTITY",
    "REMOVE_FROM_INITIAL" : "REMOVE_FROM_INITIAL"
}